import '../components/glance'

const searchGroups = document.querySelectorAll('[data-owhl-search]')

searchGroups.forEach((searchGroup) => {
    const tabs = Array.from(searchGroup.querySelectorAll('[data-search-tab]'))
    const panels = Array.from(searchGroup.querySelectorAll('[role="tabpanel"]'))

    const searchInputSelector = 'input[type="search"], input[type="text"], input:not([type])'
    const summonPanel = searchGroup.querySelector('.search__summon')

    if (summonPanel) {
        const focusSummonInput = () => {
            // Do not take focus back after the visitor has started interacting.
            if (summonPanel.hidden || (document.activeElement && document.activeElement !== document.body)) return true

            const input = summonPanel.querySelector(searchInputSelector)
            if (!input) return false

            input.focus({ preventScroll: true })
            return true
        }

        if (!focusSummonInput()) {
            const focusObserver = new MutationObserver(() => {
                if (focusSummonInput()) focusObserver.disconnect()
            })
            focusObserver.observe(summonPanel, { childList: true, subtree: true })
        }

        const addSearchIcon = () => {
            const button = summonPanel.querySelector('.summon-search-submit')
            if (!button) return false

            const label = document.createElement('span')
            label.className = 'visually-hidden'
            label.textContent = button.textContent

            const icon = document.createElement('i')
            icon.className = 'fal fa-magnifying-glass'
            icon.setAttribute('aria-hidden', 'true')
            button.replaceChildren(label, icon)
            return true
        }

        // The external widget may render after this module has loaded.
        if (!addSearchIcon()) {
            const observer = new MutationObserver(() => {
                if (addSearchIcon()) observer.disconnect()
            })
            observer.observe(summonPanel, { childList: true, subtree: true })
        }
    }

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            tabs.forEach((item) => {
                const isSelected = item === tab
                item.classList.toggle('is-active', isSelected)
                item.setAttribute('aria-selected', String(isSelected))
            })

            panels.forEach((panel) => {
                panel.hidden = panel.id !== tab.getAttribute('aria-controls')
            })

            const activePanel = searchGroup.querySelector(`#${tab.getAttribute('aria-controls')}`)
            activePanel?.querySelector(searchInputSelector)?.focus({ preventScroll: true })
        })
    })
})

// document.querySelectorAll('[data-owhl-glance]').forEach((glance) => {
//     const titles = Array.from(glance.querySelectorAll('[data-glance-title]'))
//     const images = Array.from(glance.querySelectorAll('[data-glance-image]'))
//
//     const activateItem = (index) => {
//         titles.forEach((title, titleIndex) => {
//             title.classList.toggle('is-active', titleIndex === index)
//         })
//         images.forEach((image, imageIndex) => {
//             image.classList.toggle('is-active', imageIndex === index)
//         })
//     }
//
//     titles.forEach((title, index) => {
//         title.addEventListener('mouseenter', () => activateItem(index))
//         title.addEventListener('focus', () => activateItem(index))
//     })
// })

const hero = document.querySelector('.home .home__header')
const nav = document.querySelector('.nav')

if (hero && nav?.dataset.collapsible === 'true') {
    const updateNav = () => {
        nav.classList.toggle(
            'content',
            hero.getBoundingClientRect().top * 6 + window.innerHeight <= 0
        )
    }

    window.addEventListener('scroll', updateNav, { passive: true })
    updateNav()
}
